module.exports = __webpack_public_path__ + "img/pic_161273.5f3c426c.jpg";